function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "Rectangle_3",
  x: 56.206,
  y: 19.517,
  width: 64.996,
  height: 72.604,
  filterUnits: "userSpaceOnUse"
}, React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  result: "blur"
}), React.createElement("feFlood", {
  floodOpacity: 0.149
}), React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), React.createElement("feComposite", {
  in: "SourceGraphic"
})), React.createElement("filter", {
  id: "Rectangle_899",
  x: 60.119,
  y: 31.98,
  width: 66.883,
  height: 69.205,
  filterUnits: "userSpaceOnUse"
}, React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  result: "blur-2"
}), React.createElement("feFlood", {
  floodOpacity: 0.149
}), React.createElement("feComposite", {
  operator: "in",
  in2: "blur-2"
}), React.createElement("feComposite", {
  in: "SourceGraphic"
})), React.createElement("filter", {
  id: "Rectangle_900",
  x: 65.749,
  y: 53.591,
  width: 54.948,
  height: 52.755,
  filterUnits: "userSpaceOnUse"
}, React.createElement("feOffset", {
  dy: 3,
  input: "SourceAlpha"
}), React.createElement("feGaussianBlur", {
  stdDeviation: 2.5,
  result: "blur-3"
}), React.createElement("feFlood", {
  floodOpacity: 0.149
}), React.createElement("feComposite", {
  operator: "in",
  in2: "blur-3"
}), React.createElement("feComposite", {
  in: "SourceGraphic"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Group_1950",
  "data-name": "Group 1950",
  transform: "translate(-100.502 -282)"
}, React.createElement("path", {
  id: "Path_1283",
  "data-name": "Path 1283",
  d: "M44.285,0C5.94,0-33.5,24.626-33.5,62.971S5.94,138.857,44.285,138.857,141.4,123.089,141.4,84.745,82.629,0,44.285,0Z",
  transform: "translate(134 282)",
  fill: "var(--color-secondary)"
}), React.createElement("g", {
  id: "Group_1704",
  "data-name": "Group 1704",
  transform: "translate(157.482 302.592)"
}, React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -56.98, -20.59)",
  filter: "url(#Rectangle_3)"
}, React.createElement("g", {
  id: "Rectangle_3-2",
  "data-name": "Rectangle 3",
  transform: "matrix(0.96, 0.29, -0.29, 0.96, 77.98, 24.02)",
  fill: "#fff",
  stroke: "#edf1f2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 37.356,
  height: 48.816,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 36.356,
  height: 47.816,
  fill: "none"
}))), React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -56.98, -20.59)",
  filter: "url(#Rectangle_899)"
}, React.createElement("g", {
  id: "Rectangle_899-2",
  "data-name": "Rectangle 899",
  transform: "matrix(0.82, 0.57, -0.57, 0.82, 92.18, 36.48)",
  fill: "#fff",
  stroke: "#edf1f2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 33.356,
  height: 42.816,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 32.356,
  height: 41.816,
  fill: "none"
}))), React.createElement("g", {
  transform: "matrix(1, 0, 0, 1, -56.98, -20.59)",
  filter: "url(#Rectangle_900)"
}, React.createElement("g", {
  id: "Rectangle_900-2",
  "data-name": "Rectangle 900",
  transform: "matrix(0.54, 0.84, -0.84, 0.54, 99.93, 58.09)",
  fill: "#fff",
  stroke: "#edf1f2",
  strokeWidth: 1
}, React.createElement("rect", {
  width: 24.356,
  height: 31.816,
  stroke: "none"
}), React.createElement("rect", {
  x: 0.5,
  y: 0.5,
  width: 23.356,
  height: 30.816,
  fill: "none"
})))), React.createElement("g", {
  id: "Head_Front_Chongo",
  "data-name": "Head/Front/Chongo",
  transform: "translate(140.349 327.196)"
}, React.createElement("g", {
  id: "Head",
  transform: "translate(3.382 6.087)"
}, React.createElement("path", {
  id: "Path_1268",
  "data-name": "Path 1268",
  d: "M1.863,7.775A6.107,6.107,0,0,1,.238,3.387C.577-1.437,7.293-.376,8.6,2.059s1.151,8.611-.537,9.047A5.97,5.97,0,0,1,4.494,9.974l.916,6.483H0Z",
  transform: "translate(0 0)",
  fill: "#c2d2d5",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "hair",
  d: "M48.842,9.494a7.061,7.061,0,0,0-2.264-.25,3.894,3.894,0,0,0,.276-1.968,6,6,0,0,0-.639-1.78,2.434,2.434,0,0,0-.472-.736,1.613,1.613,0,0,0-.764-.411,2.045,2.045,0,0,0-.88,0c-.128.027-.243.085-.368.118s-.191-.047-.284-.128a1.609,1.609,0,0,0-.839-.325,2.163,2.163,0,0,0-.955.114,1.868,1.868,0,0,0-.8.51A1.333,1.333,0,0,0,40.619,5c-.023.055-.027.088-.082.109s-.111.019-.164.037a2.062,2.062,0,0,0-1.185,1.074A3.406,3.406,0,0,0,39,7.622a6.085,6.085,0,0,0,1.037,2.661,3.31,3.31,0,0,0,1.71.966,4.893,4.893,0,0,0-.894,1.666,8.155,8.155,0,0,0-.409,2.024,6.607,6.607,0,0,0,.1,2,2.163,2.163,0,0,0,.967,1.408,4.619,4.619,0,0,0,.744.35,4.9,4.9,0,0,0,.767.246,1.539,1.539,0,0,0,1.456-.311,2.734,2.734,0,0,0,.391-.5c.036-.063.058-.1.014-.165a1.182,1.182,0,0,0-.206-.187A1.943,1.943,0,0,1,44,16.49a1.375,1.375,0,0,1,.594-1.44,2.2,2.2,0,0,1,1.895.346,3.1,3.1,0,0,1,1.5-1.993c.853-.429,1.831-.479,2.707-.847a1.615,1.615,0,0,0,.629-.4.813.813,0,0,0,.181-.3.479.479,0,0,0-.125-.371A6.91,6.91,0,0,0,48.842,9.494Z",
  transform: "translate(-38.998 -4)",
  fill: "#333",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Group_1949",
  "data-name": "Group 1949",
  transform: "matrix(0.883, 0.469, -0.469, 0.883, 187.489, -18.38)"
}, React.createElement("path", {
  id: "Leg",
  d: "M130,0l16.751,28.005L159.31,51.682h2.705L140.973,0Z",
  transform: "translate(12.379 368.451)",
  fill: "#c2d2d5",
  fillRule: "evenodd"
}), React.createElement("g", {
  id: "Accessories_Shoe_Flat-Sneaker",
  "data-name": "Accessories/Shoe/Flat-Sneaker",
  transform: "matrix(0.891, -0.454, 0.454, 0.891, 169.725, 419.54)"
}, React.createElement("path", {
  id: "shoe",
  d: "M1.378,20.7A4.841,4.841,0,0,0,1,22.212a11.312,11.312,0,0,0,.2,1.78H13.918q.5-1.639-.572-1.769t-1.774-.236l-5.91-2.635a.225.225,0,0,0-.3.114l0,.006-.38.921a4.054,4.054,0,0,1-1.607.461,3.638,3.638,0,0,1-1.387-.406h0a.451.451,0,0,0-.6.222Z",
  transform: "translate(-1 -19.332)",
  fill: "#333",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Pant",
  d: "M146.252,47.89l5.217-1.578q-3.428-10.249-8.4-22.557T132.378,0H117.644a231.7,231.7,0,0,0,13.464,26.314A178.111,178.111,0,0,0,146.252,47.89Z",
  transform: "translate(21.949 368.451)",
  fill: "var(--color-primary-dark)",
  fillRule: "evenodd"
})), React.createElement("g", {
  id: "Group_1948",
  "data-name": "Group 1948",
  transform: "matrix(-0.469, -0.883, 0.883, -0.469, -111.236, 682.661)"
}, React.createElement("path", {
  id: "Leg-2",
  "data-name": "Leg",
  d: "M37.028,0A225.727,225.727,0,0,1,32.11,22.8q-.288.388-20.72,6.943l.584,2.385q24.365-3.516,25.677-5.455C38.963,24.737,45.512,9.415,48.048,0Z",
  transform: "translate(104.25 368.451)",
  fill: "#c2d2d5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Pant-2",
  "data-name": "Pant",
  d: "M32.63,27.684l1.029,3.842q18.224,1.6,22.332-2.31T65.356,0H51.307q-3.33,20.723-3.724,21.593T32.63,27.684Z",
  transform: "translate(87.798 368.451)",
  fill: "var(--color-primary-dark)",
  fillRule: "evenodd"
}), React.createElement("g", {
  id: "Accessories_Shoe_Flat-Sneaker-2",
  "data-name": "Accessories/Shoe/Flat-Sneaker",
  transform: "translate(117.589 396.593) rotate(80)"
}, React.createElement("path", {
  id: "shoe-2",
  "data-name": "shoe",
  d: "M.378,1.368A4.841,4.841,0,0,0,0,2.88a11.312,11.312,0,0,0,.2,1.78H12.918q.5-1.639-.572-1.769t-1.774-.236L4.662.02a.225.225,0,0,0-.3.114l0,.006-.38.921a4.054,4.054,0,0,1-1.607.461A3.638,3.638,0,0,1,.988,1.117h0a.451.451,0,0,0-.6.222Z",
  transform: "translate(0 0)",
  fill: "#333",
  fillRule: "evenodd"
}))), React.createElement("g", {
  id: "Body_Pointing-Forward",
  "data-name": "Body/Pointing-Forward",
  transform: "translate(135.441 344.78)"
}, React.createElement("path", {
  id: "Skin",
  d: "M158.638,15.271l7.825-4.286a19.357,19.357,0,0,1,3.846-3.6c.386-.161,1.061-.259.43.862s-1.245,2.327-.923,2.672,1.123-.137,1.507.436q.384.573-4.109,1.812l-5.686,5.206Zm12.255,3.616L174.33,17q.723-2.753,1.73-2.77c.515-.24-.382,2.079.595,1.878s3.361-1.974,3.772-1.614c.608.533.066,2.168-.573,2.982-1.193,1.52-2.181,2.04-4.623,2.721a13.424,13.424,0,0,0-4.141,2.141Z",
  transform: "translate(-140.284 -5.645)",
  fill: "#c2d2d5",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Sleeve",
  d: "M1.241,1.435A19.227,19.227,0,0,0,11.892,0l.978,3.613C9.8,5.829,5.717,7.4,2.465,6.794A2.988,2.988,0,0,1,1.241,1.435Z",
  transform: "translate(13.093 7.449) rotate(-9)",
  fill: "var(--color-primary)",
  fillRule: "evenodd"
}), React.createElement("path", {
  id: "Clothes",
  d: "M95.457,14.149q4.365,1.088,14.638-2.567,2.548,5.272,2.356,7.517c-5.875,3.069-10.911,4.437-15.06,4.528a14.277,14.277,0,0,1-1.174,6.944c-2.069,4.4-14.187.325-18.261,1.127-2.551-8.286,2.382-11.653,2.386-16.955C80.346,8.937,85.008,0,85.694,0h6.255C92.295,4.434,94.032,9.321,95.457,14.149Z",
  transform: "translate(-77.224 0)",
  fill: "var(--color-primary)",
  fillRule: "evenodd"
})), React.createElement("path", {
  id: "Path_1342",
  "data-name": "Path 1342",
  d: "M8.018,47.431a5.409,5.409,0,0,0,5.393,5.393H34.984a5.409,5.409,0,0,0,5.393-5.393V15.072H8.018Z",
  transform: "translate(183.485 386.987)",
  fill: "var(--color-primary)"
}), React.createElement("path", {
  id: "Path_1343",
  "data-name": "Path 1343",
  d: "M47.252,6.018H36.689L33.671,3H18.581L15.563,6.018H5v6.036H47.252Z",
  transform: "translate(192.439 372.524) rotate(28)",
  fill: "var(--color-primary-dark)"
}), React.createElement("rect", {
  id: "Rectangle_902",
  "data-name": "Rectangle 902",
  width: 4,
  height: 27,
  transform: "translate(195 407)",
  fill: "#c2d2d5"
}), React.createElement("rect", {
  id: "Rectangle_903",
  "data-name": "Rectangle 903",
  width: 4,
  height: 27,
  transform: "translate(216 407)",
  fill: "#c2d2d5"
}), React.createElement("rect", {
  id: "Rectangle_904",
  "data-name": "Rectangle 904",
  width: 4,
  height: 27,
  transform: "translate(202 407)",
  fill: "#c2d2d5"
}), React.createElement("rect", {
  id: "Rectangle_905",
  "data-name": "Rectangle 905",
  width: 4,
  height: 27,
  transform: "translate(209 407)",
  fill: "#c2d2d5"
}));

var SvgVectorDeleteFiles = function SvgVectorDeleteFiles(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 174.898,
    height: 157.812,
    viewBox: "0 0 174.898 157.812",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgVectorDeleteFiles, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/vector-delete-files.d02b4557.svg";
export { ForwardRef as ReactComponent };